import Decimal from 'decimal.js';

export const numericStringRegex = /^(?:[1-9]\d*|0)\.?\d*$/;

export const isNumericString = str =>
  numericStringRegex.test(str?.toString() ?? '');

export const stripSpecialNumericChars = value =>
  isNumericValue(value) ||
  isNumericString(value?.toString().replace(/(\$|,|%)/g, ''))
    ? value
        ?.toString()
        .replace(/(\$|,|%)/g, '')
        ?.trim()
    : '';

export const isNumericValue = value =>
  typeof value === 'number' || isNumericString(value);

export const parseNumber = (value: string | number | Decimal) => {
  return isNaN(Number(stripSpecialNumericChars(value)))
    ? ''
    : stripSpecialNumericChars(value)
    ? new Decimal(stripSpecialNumericChars(value)).toNumber()
    : '';
};
